import { useContext } from "react";
import { ProductContext } from "../../App";
import SectionMountingsWindow from "../Sections/SectionMountingsWindow";
import SectionMountingsDoorHorizontal from "../Sections/SectionMountingsDoorHorizontal";
import SectionMountingsDoorVertical from "../Sections/SectionMountingsDoorVertical";

function Mountings() {
  const { currentConfiguration } = useContext(ProductContext);
  return (
    <>
      { 
        currentConfiguration === '4300a' ?
          <SectionMountingsWindow selectedWing="wingLeft" />
        : currentConfiguration === '4300b' ?
          <SectionMountingsDoorHorizontal selectedWing="wingLeft" />
        : 
          <SectionMountingsDoorVertical selectedWing="wingLeft" />
      }
    </>
  );
}

export default Mountings;
